import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;

  section {
    position: absolute;
    pointer-events: auto;
  }

  .linkAnnotation > a {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .linkAnnotation > a:hover {
    opacity: 0.2;
    background-color: ${theme.swatches.gray[200]};
  }
`;
